// Slug normalization — must match SlugNormalizer.cs behavior byte-for-byte.
// Parity test inputs in JUICYSTARZ-SEO-BUILD-PLAN-v3.md §3.3.
export function normalizeSlug(input: string | null | undefined): string {
  if (!input) return '';
  const lower = input.trim().toLowerCase();
  const replaced = lower.replace(/[\s_.]+/g, '-');
  const cleaned = replaced.replace(/[^a-z0-9-]/g, '');
  const collapsed = cleaned.replace(/-+/g, '-');
  return collapsed.replace(/^-+|-+$/g, '');
}
